// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import casos from '@src/views/Cases/store'
import users from '@src/views/User/store'
import email from '@src/views/email/store'
import calendar from '@src/views/calendar/store'

const rootReducer = {
  auth,
  navbar,
  layout,
  email,
  casos,
  users,
  calendar
}

export default rootReducer
